import {DomainObject, oneOf} from 'shared/store';
import { computed, observable, makeObservable } from 'mobx';

class ClockEvent extends DomainObject {
  eventType;
  createdAt;
  startTime;
  location;
  withinGeofence;
  geofenceLocation;
  projectId;
  projectName;
  note;
  clockOutError;

  _relations = {
    eventType: oneOf(['clock_in', 'clock_out'])
  };

  constructor(other) {
    super();

    makeObservable(this, {
      eventType: observable,
      createdAt: observable,
      startTime: observable,
      location: observable,
      withinGeofence: observable,
      geofenceLocation: observable,
      projectId: observable,
      projectName: observable,
      note: observable,
      clockOutError: observable,
      isClockIn: computed
    });

    this.merge(other);
  }

  get isClockIn() {
    return this.eventType === 'clock_in';
  }
}

export default ClockEvent;
